var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicChangesImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3592_12895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.5C6.198 5.5 5.75 5.052 5.75 4.5V1C5.75 0.448 6.198 0 6.75 0C7.302 0 7.75 0.448 7.75 1V4.5C7.75 5.052 7.302 5.5 6.75 5.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.5C10.948 5.5 10.5 5.052 10.5 4.5V1C10.5 0.448 10.948 0 11.5 0C12.052 0 12.5 0.448 12.5 1V4.5C12.5 5.052 12.052 5.5 11.5 5.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5.5C15.698 5.5 15.25 5.052 15.25 4.5V1C15.25 0.448 15.698 0 16.25 0C16.802 0 17.25 0.448 17.25 1V4.5C17.25 5.052 16.802 5.5 16.25 5.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 2.25H4.75C3.233 2.25 2 3.483 2 5V21.25C2 22.767 3.233 24 4.75 24H18.25C19.767 24 21 22.767 21 21.25V5C21 3.483 19.767 2.25 18.25 2.25ZM7 8H12C12.552 8 13 8.448 13 9C13 9.552 12.552 10 12 10H7C6.448 10 6 9.552 6 9C6 8.448 6.448 8 7 8ZM17 18H7C6.448 18 6 17.552 6 17C6 16.448 6.448 16 7 16H17C17.552 16 18 16.448 18 17C18 17.552 17.552 18 17 18ZM17 14H7C6.448 14 6 13.552 6 13C6 12.448 6.448 12 7 12H17C17.552 12 18 12.448 18 13C18 13.552 17.552 14 17 14Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3592_12895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicChangesImg);
export default __webpack_public_path__ + "static/media/BasicChangesImg.999a8613700df0e494d11117432f9728.svg";
export { ForwardRef as ReactComponent };